module.exports = __webpack_public_path__ + "media/images/eyecatch-caution-aspect-ratio-653314a5cf221f3018643b1c627e3ee7.svg";